/* eslint-disable camelcase */

export const generateProductUrl = ({
    url: productSlug,
    model_id,
    article_id,
}) => {
    const mailUrl = `/p/${productSlug}-${article_id}`;

    if (model_id !== article_id) {
        return `${mailUrl}?model_id=${model_id}`;
    }
    return mailUrl;
};

export const getCurrentThumbnail = ({ product, CDN, index }) => {
    if (product.thumbnails) {
        const thumbnails = product.thumbnails.sort();
        return thumbnails && thumbnails.length > 0
            ? `${CDN}/${thumbnails[index]}`
            : product.image_fullpath;
    }
    return null;
};
